import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { PrivilegeResponse, SelectMenu, SelectMenuCheckBox } from '../_models/menuModel';

@Injectable({
  providedIn: 'root'
})
export class MenuPrivilegeService {

  http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/role`;
  private baseUrl = `${environment.apiUrl}/privilege`;
  private menuUrl = `${environment.apiUrl}/menu`;

  SelectMenuPrivilege(): Observable<SelectMenu> {
    return this.http.get<SelectMenu>(`${this.apiUrl}/select`);
  }

  

  SelectMenuPrivilegeCheckBox(): Observable<SelectMenuCheckBox> {
    return this.http.get<SelectMenuCheckBox>(`${this.menuUrl}/select`);
  }

  getPrivilegeByRoleCode(roleCode: string): Observable<PrivilegeResponse> {
    const url = `${this.baseUrl}/${roleCode}`;
    return this.http.get<PrivilegeResponse>(url);
  }

  getMenuPrivilegeByRoleCode(roleCode: string): Observable<PrivilegeResponse> {
    const url = `${this.menuUrl}/${roleCode}`;
    return this.http.get<PrivilegeResponse>(url);
  }

  hasMenuPrivilege(userCode: string, menuCode: string): Observable<boolean> {
    const payload = {
      UserCode: userCode,
      MenuCode: menuCode
    };

    return this.http.post<{ hasAccess: boolean }>(`${this.baseUrl}/check-has-menu-privilege`, payload).pipe(
      map(response => response.hasAccess)
    );
  }
  
}
